(() => {
  const modal = document.querySelector('[data-scatta-request-modal]');
  if (!modal) return;

  const form = modal.querySelector('#ScattaSearchRequestForm');
  const emailInput = modal.querySelector('#ScattaRequestEmail');
  const preview = modal.querySelector('[data-scatta-request-term-preview]');
  const tagsInput = modal.querySelector('[data-scatta-request-tags]');
  const noteInput = modal.querySelector('[data-scatta-request-note]');
  const success = modal.querySelector('[data-scatta-request-success]');
  const error = modal.querySelector('[data-scatta-request-error]');
  const submitButton = modal.querySelector('.scatta-request-modal__submit');
  let currentTerm = '';
  let currentUrl = '';

  function slugify(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 50);
  }

  function getKlaviyoSettings() {
    return {
      enabled: String(modal.dataset.klaviyoEnabled || '').toLowerCase() === 'true',
      companyId: String(modal.dataset.klaviyoCompanyId || '').trim(),
      listId: String(modal.dataset.klaviyoListId || '').trim()
    };
  }

  function setLoading(isLoading) {
    if (!submitButton) return;
    submitButton.disabled = Boolean(isLoading);
    submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    submitButton.textContent = isLoading ? 'Invio...' : 'Avvisami';
  }

  function setMessage(type) {
    if (success) success.hidden = type !== 'success';
    if (error) error.hidden = type !== 'error';
  }

  function buildRequestProperties(email) {
  const requestDate = new Date().toISOString();
  const requestTitle = String(currentTerm || '').trim() || document.title;
  const requestUrl = String(currentUrl || '').trim() || window.location.href;
  const requestHandle = slugify(requestTitle);

  return {
    '$email': email,
    'email': email,

    // Proprietà leggibili in italiano dentro Klaviyo
    'Collezione richiesta': requestTitle,
    'URL collezione': requestUrl,
    'Handle collezione': requestHandle,
    'Termine cercato': requestTitle,
    'Pagina origine': window.location.href,
    'Fonte richiesta': 'Popup Avvisami quando arriva',
    'Data richiesta': requestDate,

    // Proprietà compatibili con il codice precedente
    'requested_product_search': requestTitle,
    'requested_product_slug': requestHandle,
    'requested_product_url': requestUrl,
    'request_source': 'Scatta Search Popup',
    'last_search_request': requestTitle,
    'last_search_request_url': requestUrl,
    'last_search_request_date': requestDate
  };
}

  function trackKlaviyoEvent(email) {
    const profileProps = buildRequestProperties(email);
    const eventProps = {
      'Search Term': currentTerm,
      'Search Term Slug': slugify(currentTerm),
      'Request URL': currentUrl,
      'Source': 'Scatta Search Popup'
    };

    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function' && typeof window.klaviyo.track === 'function') {
        Promise.resolve(window.klaviyo.identify(profileProps))
          .then(() => window.klaviyo.track('Requested Product Search', eventProps))
          .catch(() => window.klaviyo.track('Requested Product Search', eventProps));
        return;
      }

      if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['identify', profileProps]);
        window._learnq.push(['track', 'Requested Product Search', eventProps]);
      }
    } catch (err) {
      // Tracking must never block the form submission.
      console.warn('Scatta Klaviyo tracking skipped', err);
    }
  }

  async function subscribeToKlaviyo(email) {
  const settings = getKlaviyoSettings();

  if (!settings.enabled || !settings.companyId || !settings.listId) {
    return { ok: false, missingSettings: true };
  }

  const profileProps = buildRequestProperties(email);

  const payload = {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: 'Scatta - Avvisami quando arriva',
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              properties: {
                'Collezione richiesta': profileProps['Collezione richiesta'],
                'URL collezione': profileProps['URL collezione'],
                'Handle collezione': profileProps['Handle collezione'],
                'Termine cercato': profileProps['Termine cercato'],
                'Pagina origine': profileProps['Pagina origine'],
                'Fonte richiesta': profileProps['Fonte richiesta'],
                'Data richiesta': profileProps['Data richiesta'],
                requested_product_search: profileProps.requested_product_search,
                requested_product_slug: profileProps.requested_product_slug,
                requested_product_url: profileProps.requested_product_url,
                request_source: profileProps.request_source,
                last_search_request: profileProps.last_search_request,
                last_search_request_url: profileProps.last_search_request_url,
                last_search_request_date: profileProps.last_search_request_date
              },
              subscriptions: {
                email: {
                  marketing: {
                    consent: 'SUBSCRIBED'
                  }
                }
              }
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: settings.listId
          }
        }
      }
    }
  };

  const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(settings.companyId)}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
      'revision': '2026-07-15'
    },
    body: JSON.stringify(payload)
  });

  return { ok: response.ok, status: response.status };
}

async function createKlaviyoRequestEvent(email) {
  const settings = getKlaviyoSettings();

  if (!settings.enabled || !settings.companyId) {
    return { ok: false, missingSettings: true };
  }

  const props = buildRequestProperties(email);

  const payload = {
    data: {
      type: 'event',
      attributes: {
        properties: {
          'Collezione richiesta': props['Collezione richiesta'],
          'URL collezione': props['URL collezione'],
          'Handle collezione': props['Handle collezione'],
          'Termine cercato': props['Termine cercato'],
          'Pagina origine': props['Pagina origine'],
          'Fonte richiesta': props['Fonte richiesta'],
          'Data richiesta': props['Data richiesta']
        },
        metric: {
          data: {
            type: 'metric',
            attributes: {
              name: 'Avvisami Quando Arriva'
            }
          }
        },
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: email,
              properties: {
                'Ultima collezione richiesta': props['Collezione richiesta'],
                'Ultima URL collezione richiesta': props['URL collezione'],
                'Ultimo termine cercato': props['Termine cercato'],
                'Ultima richiesta Avvisami': props['Data richiesta'],
                'Fonte ultima richiesta': props['Fonte richiesta']
              }
            }
          }
        }
      }
    }
  };

  const response = await fetch(`https://a.klaviyo.com/client/events?company_id=${encodeURIComponent(settings.companyId)}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
      'revision': '2026-07-15'
    },
    body: JSON.stringify(payload)
  });

  return { ok: response.ok, status: response.status };
}

  function open(term, url) {
    currentTerm = String(term || '').trim() || document.querySelector('input[type="search"]')?.value || document.title;
    currentUrl = url || window.location.href;
    if (preview) preview.textContent = `Richiesta: ${currentTerm}`;
    if (tagsInput) {
      const termTag = slugify(currentTerm);
      tagsInput.value = `richiesta-prodotto,search-request${termTag ? ',richiesta-' + termTag : ''}`;
    }
    if (noteInput) noteInput.value = `Prodotto/collezione richiesta: ${currentTerm} | URL: ${currentUrl}`;
    setMessage(null);
    setLoading(false);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    window.setTimeout(() => emailInput?.focus(), 80);
  }

  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-scatta-request-open]');
    if (openBtn) {
      event.preventDefault();
      open(openBtn.dataset.scattaRequestTerm, openBtn.dataset.scattaRequestUrl);
      return;
    }
    if (event.target.closest('[data-scatta-request-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

 form?.addEventListener('submit', async (event) => {
  event.preventDefault();

  const email = emailInput?.value?.trim() || '';
  if (!email) return;

  const settings = getKlaviyoSettings();

  console.log('Scatta Klaviyo settings:', settings);

  if (!settings.enabled || !settings.companyId || !settings.listId) {
    console.warn('Scatta Klaviyo non configurato correttamente. Controlla toggle, Site ID e List ID nel tema.');
    setMessage('error');
    return;
  }

  setLoading(true);
  setMessage(null);

  try {
    const subscriptionResult = await subscribeToKlaviyo(email);
    const eventResult = await createKlaviyoRequestEvent(email);

    trackKlaviyoEvent(email);

    console.log('Scatta Klaviyo subscription result:', subscriptionResult);
    console.log('Scatta Klaviyo event result:', eventResult);

    if (subscriptionResult.ok || eventResult.ok) {
      setMessage('success');
      form.reset();
    } else {
      setMessage('error');
    }
  } catch (err) {
    console.warn('Scatta Klaviyo request failed', err);
    setMessage('error');
  } finally {
    setLoading(false);
  }
});
})();